import { Component, OnInit } from '@angular/core';
import { FormUtils } from 'app/tools/form-utils';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-nr-protocolo-troca-veiculo',
  templateUrl: './text-nr-protocolo-troca-veiculo.component.html',
  styleUrls: ['./text-nr-protocolo-troca-veiculo.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNrProtocoloTrocaVeiculoComponent implements OnInit {

  public mask = FormUtils.NR_PROTOCOLO;
  constructor() { }

  ngOnInit() {
  }

}
